import React, { useState, useEffect } from "react";
import { Container, Spinner } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import Button from "@mui/material/Button";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import TeamTable from "../../Components/ProjectSubmission/teamTable";
import { useNavigate, useParams } from "react-router-dom";
import { getProjectDetails, updateProjectStatus } from "../../api/casp/project";
import { ProjectStatuses } from "../../constants/Status";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import DocumentTab from "../../Components/ProjectSubmission/documentsTab";
import { useSelector } from "react-redux";
import ProjectInfo from "../../Components/ProjectSubmission/projectInfo";
import CreateDeliverable from "../../Components/casp/deliverable/CreateDeliverable";
import DeliverableAccordion from "../../Components/casp/deliverable/DeliverableAccordion";
import SettingsIcon from '@mui/icons-material/Settings';
import Stakeholders from "../../Components/casp/stakeholder";
import { Helmet } from 'react-helmet';
import { getIconPath, getUrl } from "../../helpers/file_helper";
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import GroupsIcon from '@mui/icons-material/Groups';
import ConstructionIcon from '@mui/icons-material/Construction';
import dayjs from "dayjs";
import { ProjectStatusColor } from "../../constants/StatusColor";
import DescriptionIcon from "@mui/icons-material/Description";
import { hasModulePermission } from "../../helpers/permission";
import ShowCommentModal from "../../Components/casp/common/ShowCommentModal";
import { Modules } from "../../constants/Module";
import { Action, ProjectTag, Role } from "../../constants/Common";
import { toast } from "react-toastify";
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Drawer from '@mui/material/Drawer';
import { withTranslation } from "react-i18next";
import ContentInfo from "../../common/contentInfo";
import Loader from "../../Components/Common/Loader";
import AddProjectDrawer from "../../Components/casp/project/AddProjectDrawer";
import Actionlog from "../../Components/casp/actionlog";
import SuccessStoriesTab from "../../Components/ProjectSubmission/SuccessStories/SuccessStoriesTab";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 2 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function allTabsProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ViewProjectSubmission = (props) => {
  const [value, setValue] = useState(0);
  const [selectedTab, setSelectedTab] = useState();
  const [refresh, setRefresh] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [tabHide, setTabHide] = useState(true);
  const [projectStatus, setProjectStatus] = useState()
  const [ticketStatusDisable, setTicketStatusDisable] = useState(true)
  const [projectDetails, setProjectDetails] = useState()
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingForSubmit, setIsLoadingForSubmit] = useState(false);
  const [openRejectModel, setOpenRejectModel] = useState(false);
  const [rejectReason, setRejectReason] = useState();
  const [update, setUpdate] = useState(0)
  const [action, setAction] = useState()
  const { project } = useParams();
  const isCompanySpecific = ['NTDP', 'JST','RCT'].includes(loggedInUser.company?.name)
  let index = 0;
  let matchIndex = 0;
  const hasPermission = hasModulePermission(Modules.PROJECT, Action.EDIT)
  const { projectUser } = useSelector((state) => ({
    projectUser: state.projectUser.projectUser,
  }));
  const isManager = projectUser?.role?.name === Role.PROJECT_MANAGER
  const hasCreatePermissionForDeliverable = hasModulePermission(Modules.DELIVERABLE, Action.CREATE)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [rightDrawer, setRightDrawer] = useState({
    right: false
  });

  const toggleDrawer = (anchor, open) => (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setRightDrawer({ ...rightDrawer, [anchor]: open });
  };

  const navigate = useNavigate();

  useEffect(() => {
    const selectedMenu = parseInt(sessionStorage.getItem('selectedTab'));
    if (selectedMenu) {
      setValue(selectedMenu)
      sessionStorage.clear();
    }
  }, [])

  useEffect(() => {
    if (project) {
      getProjectInfo(project);
    }
  }, [project,selectedTab]);

  const getProjectInfo = async (id) => {
    try {
      setIsLoading(true)
      const res = await getProjectDetails(id);
      setProjectStatus(res.data.data.status)
      if (
        (res.data.data.status &&
          [
            // ProjectStatuses.COMPLETED,
            ProjectStatuses.IN_APPROVAL,
            ProjectStatuses.SENT_FOR_CONFIRMATION,
          ].includes(res.data.data.status)) || res.data.data.tag !== ProjectTag.ACTIVE
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }

      if (
        res.data.data.status &&
        [
          ProjectStatuses.DRAFT,
          ProjectStatuses.REJECTED,
          ProjectStatuses.IN_APPROVAL,
          ProjectStatuses.COMPLETED,
        ].includes(res.data.data.status)
      ) {
        setTabHide(true);
      } else {
        setTabHide(false);
      }

      if (
        res.data.data.status && ProjectStatuses.ONGOING !== res.data.data.status && res.data.data.tag !== ProjectTag.ACTIVE) {
        setTicketStatusDisable(true);
      } else {
        setTicketStatusDisable(false);
      }
      setProjectDetails(res.data.data)
    } catch (error) {
      toast.error(error.message)
    } finally {
      setIsLoading(false)
    }

  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal((prev) => !prev);
  };
  useEffect(() => {
    switch (value) {
      case 1:
        setSelectedTab({
          icon: <PollOutlinedIcon />,
          title: props.t('Deliverables & Milestones')
        })
        break;
      case 2:
        setSelectedTab({
          icon: <CheckBoxOutlinedIcon />,
          title: props.t('Tasks')
        })
        break;
      case 3:
        tabHide ?
          setSelectedTab({
            icon: <GroupsOutlinedIcon />,
            title: props.t('Team')
          }) :
          setSelectedTab({
            icon: <PublishedWithChangesIcon />,
            title: props.t('Change Request List')
          })
        break;
      case 4:
        tabHide ?
          setSelectedTab({
            icon: <ReportProblemOutlinedIcon />,
            title: props.t('Risk Register')
          }) :
          setSelectedTab({
            icon: <GroupsOutlinedIcon />,
            title: props.t('Team')
          })
        break;
      case 5:
        tabHide ?
          setSelectedTab({
            icon: <DescriptionOutlinedIcon />,
            title: props.t('Documents')
          }) :
          setSelectedTab({
            icon: <ReportProblemOutlinedIcon />,
            title: props.t('Risk Register')
          })
        break;
      case 6:
        tabHide ?
          setSelectedTab({
            icon: <GroupsIcon />,
            title: props.t('Offtakers')
          }) :
          setSelectedTab({
            icon: <DescriptionOutlinedIcon />,
            title: props.t('Documents')
          })
        break;
      case 7:
        tabHide ?
          setSelectedTab({
            icon: <SettingsIcon />,
            title: props.t('Startup Settings')
          }) :
          setSelectedTab({
            icon: <ConstructionIcon />,
            title: props.t('Challenges')
          })
        break;
      case 8:
        setSelectedTab({
          icon: <GroupsIcon />,
          title: props.t('Offtakers')
        })
        break;
      case 9:
        setSelectedTab({
          icon: <SettingsIcon />,
          title: props.t('Startup Settings')
        })
        break;
      case 10:
        setSelectedTab({
          icon: <SettingsIcon />,
          title: props.t('Activity Log')
        })
        break;
      case 0:
      default:
        setSelectedTab({
          icon: <DashboardOutlinedIcon />,
          title: props.t('Startup Information')
        })
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const handleOpen = (comment, data) => {
    setOpenRejectModel(true);
    setRejectReason({
      name: data?.name,
      profilePicture: data?.profilePicture,
      role: data?.projectUsers[0]?.role?.name ?? '',
      comment,
    });
  };

  const projectSubmit = async () => {
    try {
      if (isCompanySpecific && [ProjectStatuses.DRAFT, ProjectStatuses.REJECTED].includes(projectDetails.status) ? (!projectDetails?.description || !projectDetails?.sector) : false) {
        return toast.error('Please fill up all the fields before submitting startup.')
      }
      else if (!projectDetails?.description) {
        return toast.error('Please add description before submit project')
      }

      setIsLoadingForSubmit(true);
      const res = await updateProjectStatus(project, {
        status: [ProjectStatuses.ONGOING, ProjectStatuses.CONFIRMATION_REJECTED].includes(projectDetails.status) ? ProjectStatuses.COMPLETED : ProjectStatuses.ONGOING,
      });
      if (res.statusCode === 200) {
        toast.success(res.data.message);
        getProjectInfo(project)
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      setIsLoadingForSubmit(false);
      toast.error(error.message);
    }
  };

  const handleRejectModal = () => {
    setOpenRejectModel(!openRejectModel);
    setRejectReason()
  };

  const handleCloseDrawer = async (message) => {
    setIsDrawerOpen(false);
    if (message === "success" || message === "success_story_updated" || message === "success_story_created") {
      await getProjectInfo(project);
      setUpdate(update + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, "linkTags", []), {
                rel: "icon",
              });

              if (!newFaviconElems.length) {
                return;
              }

              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href;

              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              );

              if (existingFavicons.length) {
                existingFavicons.forEach((e) => e.parentNode.removeChild(e));
              }

              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              );

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true);
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(
                    selectedTab?.icon
                  )}</svg>`
                )}`;
                const parentElem = newFaviconElem.parentNode;
                parentElem.removeChild(newFaviconElem);
                parentElem.appendChild(newFavElement);
              }
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <title>{selectedTab?.title ?? ""}</title>
        </Helmet>
        <Container fluid>
          {projectStatus && (
            <>
              {/* BreadCrumb area starts */}
              <div className="mainPageHeader d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <ArrowBackOutlinedIcon
                    className="me-2 cursor-pointer"
                    onClick={() => navigate(-1)}
                  />
                  {isCompanySpecific && projectDetails?.logo?.name && (
                    <div className="breadcrumb_profile">
                      <img
                        src={getUrl(projectDetails?.logo?.storageLink)}
                        alt={projectDetails?.logo?.name}
                      />
                    </div>
                  )}
                  <BreadCrumb
                    title={
                      projectDetails ? projectDetails.name : "Startup Name"
                    }
                  />
                </div>
                <div className=" d-flex justify-content-center align-items-center">
                  <h6
                    className={`statusBadge ${ProjectStatusColor(
                      projectDetails?.status
                    )} badge-outlined mt-2 ${projectDetails?.status !== ProjectStatuses.REJECTED
                      ? "mx-2 "
                      : ""
                      }`}
                  >
                    {props.t(projectDetails?.status)}
                    {[
                      ProjectStatuses.IN_APPROVAL,
                      ProjectStatuses.SENT_FOR_CONFIRMATION,
                    ].includes(projectDetails.status) && (
                        <ContentInfo
                          content={
                            projectDetails?.latestApproval?.currentApprovalUser
                          }
                        />
                      )}
                    {[
                      ProjectStatuses.REJECTED,
                      ProjectStatuses.CONFIRMATION_REJECTED,
                    ].includes(projectDetails.status) && (
                        <DescriptionIcon
                          style={{ cursor: "pointer", height: "18px" }}
                          onClick={() =>
                            handleOpen(
                              projectDetails.previousApproval?.comments,
                              projectDetails.previousApproval?.currentApprovalUser
                                ?.user
                            )
                          }
                        />
                      )}
                  </h6>
                  {hasPermission &&
                    isManager &&
                    [
                      ProjectStatuses.DRAFT,
                      ProjectStatuses.REJECTED,
                    ].includes(projectDetails?.status) && (
                      <button
                        onClick={projectSubmit}
                        className="edit_button deliverables_submit"
                        disabled={isLoadingForSubmit}
                      >
                        {isLoadingForSubmit && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-1"
                          />
                        )}
                        {props.t("Submit")}
                      </button>
                    )}
                  {hasPermission &&
                    isManager &&
                    [
                      ProjectStatuses.DRAFT,
                      ProjectStatuses.REJECTED,
                      ProjectStatuses.ONGOING,
                    ].includes(projectStatus) &&
                    // isCompanySpecific && 
                    (
                      <button
                        onClick={() => {
                          setAction(Action.EDIT);
                          setIsDrawerOpen(true);
                        }}
                        className="edit_button deliverables_submit ms-3"
                      >
                        {[
                          ProjectStatuses.DRAFT,
                          ProjectStatuses.REJECTED,
                        ].includes(projectStatus)
                          ? props.t("Complete Details")
                          : props.t("Edit Details")}
                      </button>
                    )}
                  {![ProjectStatuses.DRAFT, ProjectStatuses.REJECTED].includes(
                    projectStatus
                  ) &&
                    // isCompanySpecific && 
                    (
                      <button
                        onClick={() => {
                          setAction(Action.VIEW);
                          setIsDrawerOpen(true);
                        }}
                        className="edit_button deliverables_submit ms-3"
                      >
                        {props.t("View Additional Details")}
                      </button>
                    )}
                </div>
              </div>
              <div className="projectSubmissionView accordionTable">
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ borderBottom: 3, borderColor: "divider" }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                    >
                      <Tab
                        icon={<AssignmentLateOutlinedIcon />}
                        label={props.t("Startup Info")}
                        className="tab_btn required"
                        {...allTabsProps(index++)}
                      />
                      {
                        [ProjectStatuses.ONGOING,ProjectStatuses.COMPLETED].includes(projectDetails?.status) &&
                        <Tab
                          icon={<FactCheckOutlinedIcon />}
                          className="tab_btn required"
                          label={props.t("Deliverables")}
                          {...index++}
                        />
                      }
                      {/* Hide Task tab */}
                      {/* <Tab
                        icon={<AssignmentTurnedInOutlinedIcon />}
                        label={props.t("Task")}
                        className="tab_btn"
                        {...allTabsProps(index++)}
                      /> */}
                      {/* Hide Change Request Tab */}
                      {/* {!tabHide && (
                        <Tab
                          icon={<AutorenewOutlinedIcon />}
                          label={props.t("Change Request")}
                          className="tab_btn"
                          {...allTabsProps(index++)}
                        />
                      )} */}
                      <Tab
                        icon={<PeopleOutlineOutlinedIcon />}
                        className="tab_btn"
                        label={props.t("Team")}
                        {...allTabsProps(index++)}
                      />
                      {/* Hide Risk Register  Tab*/}
                      {/* <Tab
                        icon={<ReportProblemOutlinedIcon />}
                        className="tab_btn required"
                        label={props.t("Risk Register")}
                        {...allTabsProps(index++)}
                        /> */}
                      <Tab
                        icon={<StickyNote2OutlinedIcon />}
                        className="tab_btn required"
                        label={props.t("Startup Files")}
                        {...allTabsProps(index++)}
                      />
                      {/* Hide Challenges Tab*/}
                      {/* {!tabHide && (
                        <Tab
                          icon={<ConstructionOutlinedIcon />}
                          label={props.t("Challenges")}
                          className="tab_btn"
                          {...allTabsProps(index++)}
                        />
                      )} */}
                      <Tab
                        icon={<PeopleAltOutlinedIcon />}
                        className="tab_btn required"
                        label={props.t("Offtakers")}
                        {...allTabsProps(index++)}
                      />
                      <Tab
                        icon={<SettingsOutlinedIcon />}
                        label={props.t("Activity Log")}
                        className="tab_btn"
                        {...allTabsProps(index++)}
                      />
                      <Tab
                        icon={<PeopleAltOutlinedIcon />}
                        label={props.t("Success Stories")}
                        className="tab_btn"
                        {...allTabsProps(index++)}
                      />
                      {/* Hide Startup Settings tab */}
                      {/* <Tab
                        icon={<SettingsOutlinedIcon />}
                        label={props.t("Startup Settings")}
                        className="tab_btn"
                        {...allTabsProps(index++)}
                      /> */}
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={value} index={matchIndex++}>
                    <ProjectInfo key={update} />
                  </CustomTabPanel>
                  {
                    [ProjectStatuses.ONGOING,ProjectStatuses.COMPLETED].includes(projectDetails?.status) &&
                    <CustomTabPanel value={value} index={matchIndex++}>
                      {/* BreadCrumb area starts */}
                      <div className="mainPageHeader d-flex justify-content-between mb-4">
                        <div className="tabsPageHeader d-flex align-items-center">
                          <BreadCrumb title={props.t("Deliverables Details")} />
                        </div>
                        {[
                          ProjectStatuses.DRAFT,
                          ProjectStatuses.REJECTED,
                        ].includes(projectDetails?.status) &&
                          hasCreatePermissionForDeliverable && (
                            <Button
                              variant="contained"
                              className="popupButton edit_button main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary btn-height-30"
                              disableElevation
                              onClick={toggleDrawer("right", true)}
                              disabled={disabled}
                            >
                              <AddOutlinedIcon /> &nbsp; {props.t("Deliverables")}
                            </Button>
                          )}
                      </div>
                      <div className="tabContent taskOverview remBorderTop">
                        <DeliverableAccordion
                          key={refresh}
                          disabled={disabled}
                          projectDetails={{
                            status: projectDetails?.status,
                            projectCost: projectDetails?.projectCost,
                            startDate: projectDetails?.startDate,
                            endDate: projectDetails?.endDate,
                            portfolioId: projectDetails?.portfolioId
                          }}
                        />
                      </div>
                    </CustomTabPanel>
                  }
                  {/* Hide Task Tab */}
                  {/* <CustomTabPanel value={value} index={matchIndex++}>
                    <TaskTable projectId={project} ticketStatusDisable={ticketStatusDisable} disabled={disabled} selectedTab={selectedTab} value={value} projectStatus={projectStatus}/>
                  </CustomTabPanel> */}
                  {/* Hide Change Request Tab */}
                  {/* {!tabHide && (
                    <CustomTabPanel value={value} index={matchIndex++}>
                      <ChangeRequestTab projectId={project} disabled={disabled} />
                    </CustomTabPanel>
                  )} */}
                  <CustomTabPanel value={value} index={matchIndex++}>
                    <TeamTable
                      projectId={project}
                      projectStatus={projectStatus}
                      disabled={disabled}
                    />
                  </CustomTabPanel>
                  {/* Hide Risk Register Tab */}
                  {/* <CustomTabPanel value={value} index={matchIndex++}>
                    <RiskTable projectId={project} disabled={disabled} />
                  </CustomTabPanel> */}
                  <CustomTabPanel value={value} index={matchIndex++}>
                    <DocumentTab />
                  </CustomTabPanel>
                  {/* Hide Challenges Tab */}
                  {/* {!tabHide && (
                    <CustomTabPanel value={value} index={matchIndex++}>
                      <ChallengesTable
                        projectId={project}
                        disabled={disabled}
                        projectStartDate={projectDetails?.startDate}
                      />
                    </CustomTabPanel>
                  )} */}

                  <CustomTabPanel value={value} index={matchIndex++}>
                    <Stakeholders
                      disabled={projectDetails?.tag !== ProjectTag.ACTIVE}
                    />
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={matchIndex++}>
                    <Actionlog projectId={project} />
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={matchIndex++}>
                    <SuccessStoriesTab projectId={parseInt(project)} project={project} refresh={update} />
                  </CustomTabPanel>
                  {/* Hide Startup Settings Tab */}
                  {/* <CustomTabPanel value={value} index={matchIndex++}>
                    <ProjectSettings projectId={project} disabled={disabled} />
                  </CustomTabPanel> */}
                </Box>
              </div>
            </>
          )}
          {!projectStatus && isLoading && <Loader />}
          {/* { !projectStatus && !isLoading && <NotFound/> } */}
        </Container>
      </div>

      <Drawer
        anchor="right"
        open={rightDrawer.right}
        onClose={toggleDrawer("right", false)}
        PaperProps={{
          sx: { width: "580px" },
        }}
        className="projectListDrawer"
      >
        {projectDetails && (
          <CreateDeliverable
            isOpen={rightDrawer.right}
            setIsOpen={toggleDrawer("right", false)}
            emitProject={setRefresh}
            projectCost={projectDetails.projectCost}
            projectStartDate={dayjs(projectDetails.startDate).format(
              "YYYY-MM-DD"
            )}
            projectEndDate={dayjs(projectDetails.endDate).format("YYYY-MM-DD")}
          />
        )}
      </Drawer>

      {/* <Modal
        isOpen={modal}
        toggle={toggle}
        centered
        backdrop="static"
      >
        {
          projectDetails &&
            <CreateDeliverable
              isOpen={modal}
              setIsOpen={setModal}
              emitProject={setRefresh}
              projectCost={projectDetails.projectCost}
              projectStartDate={dayjs(projectDetails.startDate).format("YYYY-MM-DD")}
              projectEndDate={dayjs(projectDetails.endDate).format("YYYY-MM-DD")}
            />
        }
      </Modal> */}

      <div className="rejectModal">
        <ShowCommentModal
          handleRejectModal={handleRejectModal}
          open={openRejectModel}
          module={Modules.CHANGE_REQUEST}
          data={rejectReason}
        />
      </div>

      {isDrawerOpen && (
        <AddProjectDrawer
          isOpen={isDrawerOpen}
          handleClose={handleCloseDrawer}
          action={action}
          selectedProjectRow={{ id: parseInt(project) }}
        />
      )}
    </React.Fragment>
  );
}

export default withTranslation()(ViewProjectSubmission);
